/**
 * Copied and then modified from:
 *
 * @see {@link https://github.com/react-hook-form/error-message/blob/2cb9e332bd4ca889ac028a423328e4b3db7d4765/src/ErrorMessage.tsx}
 *
 * @remarks
 *
 * The original version of this helper component does not support root error
 * messages which RHF uses for e.g. array fields when there's an error on the
 * list and not on an individual item's fields.
 */
import * as React from 'react';
import { FieldErrors, get, useFormContext } from 'react-hook-form';

import { Props } from './types';

const ErrorMessage = <
  TFieldErrors extends FieldErrors,
  TAs extends
    | undefined
    | React.ReactElement
    | React.ComponentType<unknown>
    | keyof JSX.IntrinsicElements = undefined,
>({
  as,
  errors,
  name,
  message,
  render,
  ...rest
}: Props<TFieldErrors, TAs>) => {
  const methods = useFormContext();
  const error = get(errors || methods.formState.errors, name);

  if (!error) {
    return null;
  }

  const { message: messageFromRegister, root, types } = error;
  const { message: messageFromRoot } = root || {};

  const props = Object.assign({}, rest, {
    children: messageFromRegister || message || messageFromRoot,
  });

  return React.isValidElement(as)
    ? React.cloneElement(as, props)
    : render
      ? (render({
          message: messageFromRegister || message || messageFromRoot,
          messages: types,
        }) as React.ReactElement)
      : React.createElement((as as string) || React.Fragment, props);
};

export { ErrorMessage };
